import firebase from "firebase/app";
import "firebase/analytics";

export interface AnalyticsService {
  logEvent(event: string);
}

export class AnalyticsServiceImpl implements AnalyticsService {
    constructor() {
        firebase.analytics()
    }
    logEvent(event: string) {
        firebase.analytics().logEvent(event)
        const FB = (window as any).FB
        if(FB) {
            FB.AppEvents.logEvent("buttonClicked")
        }
        else {
            console.warn("FB undefined");
        }
    }
}